import { API_BASE_URL } from "../../config";

interface ApiFetchOptions {
  method?: string;
  headers?: HeadersInit;
  body?: any;
}

export const apisubscriberFetch = async (
  endpoint: string,
  options: ApiFetchOptions = {},
) => {
  const { method = "GET", headers = {}, body } = options;

  try {
    const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
      method,
      headers: {
        "Content-Type": "application/json",
        ...headers,
      },
      body: method !== "GET" && body ? body : undefined,
    });

    // ================= PARSE RESPONSE =================
    let data: any = {};

    try {
      data = await response.json();
    } catch (e) {
      data = { message: "No response body" };
    }

    return {
      status: response.status,
      ok: response.ok,
      data,
    };
  } catch (error: any) {
    console.error("API Error:", error);

    return {
      status: 0,
      ok: false,
      data: {
        message: error.message || "Unknown error",
      },
    };
  }
};
